import { IStationPrice } from 'dataSources/Typicode/stations';

import { ChargePriceType } from 'entities/stations';

const calculateExcise = (priceNetto: number, priceExcise: number) => {
  return parseFloat((priceNetto - priceExcise).toFixed(3));
};

export const getStationServicePriceByPriceType = (priceType: number | string, stationPrice?: IStationPrice) =>
  ({
    [ChargePriceType.NetPrice]: {
      amount: stationPrice?.clientPriceNettoInEuro,
      currency: 'EUR',
    },
    [ChargePriceType.GrossPrice]: {
      amount: stationPrice?.clientPriceBruttoInEuro,
      currency: 'EUR',
    },
    [ChargePriceType.NetExcise]: {
      amount: stationPrice?.clientPriceNettoInEuro
        ? calculateExcise(stationPrice.clientPriceNettoInEuro, stationPrice.exciseInEuro ?? 0)
        : null,
      excise: stationPrice?.exciseInEuro,
      currency: 'EUR',
    },
  })[Number(priceType)] || null;

export const getStationServiceClientPriceByPriceType = (priceType: number | string, stationPrice?: IStationPrice) =>
  ({
    [ChargePriceType.NetPrice]: stationPrice?.clientPriceNetto,
    [ChargePriceType.GrossPrice]: stationPrice?.clientPriceBrutto,
    [ChargePriceType.NetExcise]: {
      amount: stationPrice?.clientPriceNettoInEuro
        ? calculateExcise(stationPrice.clientPriceNettoInEuro, stationPrice?.exciseInEuro ?? 0)
        : null,
      excise: stationPrice?.exciseInEuro,
      currency: 'EUR',
    },
  })[Number(priceType)] || null;
